<template>
  <div id="app">
    <v-main>
      <Upper />
      <!-- <router-view /> -->
      <v-row no-gutters style="margin-top: 250px">
        <v-col cols="3" md="3" sm="3" xs="3" align="center"> </v-col>
        <v-col cols="6" md="6" sm="5" xs="5" align="center">
          <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center" class="ml-3">
          <span class="kanitFamily"> LOADING..... </span>
        </v-col>
      </v-row>
    </v-main>
  </div>
</template>

<script>
import Upper from "../upper.vue";
export default {
  components: { Upper },
  data() {
    return {
      userData: "",
      dataroom: "",
      namepagejoin: "",
      namepagejointolobby: "",
      jwt: require("jsonwebtoken"),
    };
  },
  mounted() {
    var sharetoken = this.$route.query.shared_token;
    // this.$swal('this.sharetokenmail.join =', this.$route.query.shared_token , 'warning')
    if (sharetoken === null || sharetoken === "" || sharetoken === undefined) {
      this.uuid = this.$route.query.uuid;
      if (this.uuid === null || this.uuid === undefined) {
        this.$swal
          .fire({
            title: this.$t("message.nomeeting"),
            // text: 'กรุณาเข้าสู่ระบบ',
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false,
          })
          .then(res => {
            window.location.href = "/";
          });
      } else {
        this.checkroom();
      }
    } else {
      localStorage.clear();
      this.uuid = this.$route.query.uuid;
      localStorage.setItem("share-token", sharetoken);
      this.$router.push({ path: "/loadinglogin" + "/?uuid=" + this.uuid }).catch(() => { });
      //     this.uuid = this.$route.query.uuid
      // if (this.uuid === null || this.uuid === undefined) {
      //   this.$swal
      //     .fire({
      //       title: this.$t("message.nomeeting"),
      //       // text: 'กรุณาเข้าสู่ระบบ',
      //       icon: 'warning',
      //       showCancelButton: false,
      //       confirmButtonText: 'OK',
      //       allowOutsideClick: false
      //     }).then(res => {
      //       window.location.href = '/'
      //     }
      //     )
      // } else {
      //   this.checkroom()
      // }
    }
  },
  created() {
    this.namepagejoin = this.$route.query.T;
  },
  methods: {
    checkroom() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/lv1/join/check/" + this.uuid)
        .then(res => {
          if (res.data.result === "Success") {
            if (res.data.message === "This meeting room is closed.") {
              this.$swal(
                this.$t("message.meetingclosed"),
                this.$t("message.tryagain"),
                "warning"
              ).then(res => {
                this.$router.push({ path: "/" }).catch(() => { });
              });
            } else {
              this.dataroom = JSON.parse(this.decodeJS(res.data.data));
              // console.log('checkroom1', this.dataroom.loa)
              if (
                this.dataroom.loa === "" ||
                this.dataroom.loa === null ||
                this.dataroom.loa === undefined
              ) {
                // console.log('user-token if', localStorage.getItem('user-token'))
                // console.log("dataroom.setting.login === ") 
                  if (this.dataroom.setting.login === true) {
                    if (this.dataroom.setting.secretroom === true) {
                      this.checkmobile();
                      // this.$router
                      //   .push({
                      //     path: "/otp" + "/?uuid=" + this.uuid,
                      //     params: { schedule: 1 },
                      //   })
                      //   .catch(() => {});
                    } else {
                      if (localStorage.getItem("user-token") === null) {
                        this.$router
                          .push({
                            path: "/LobbyIncognito" + "/?uuid=" + this.uuid,
                            params: { schedule: 1 },
                          })
                          .catch(() => { });
                      } else {
                        this.$router
                          .push({
                            path: "/lobbyJoin" + "/?uuid=" + this.uuid,
                            params: { schedule: 1 },
                          })
                          .catch(() => { });
                      }
                    }
                    // console.log('dataroom.setting.login === true')
                    // console.log('this.dataroom.setting.SecretRoom', this.uuid)
                    // if (localStorage.getItem('user-token') === null) {
                    //   this.$router.push({ path: '/LobbyIncognito' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
                    // } else {
                    //   // console.log('dataroom.setting.login === F')
                    //   this.$router.push({ path: '/lobbyJoin' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
                    // }
                  } else {
                    // console.log('else')
                    // console.log('user-token else', localStorage.getItem('user-token'))
                    if (this.dataroom.setting.secretroom === true) {
                      this.$router
                        .push({
                          path: "/otp" + "/?uuid=" + this.uuid,
                          params: { schedule: 1 },
                        })
                        .catch(() => { });
                    } else {
                      //   if (localStorage.getItem('user-token') === null) {
                      //   this.$router.push({ path: '/LobbyIncognito' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
                      // } else {
                      // console.log('dataroom.setting.login === F')
                      this.$router
                        .push({
                          path: "/lobbyJoin" + "/?uuid=" + this.uuid,
                          params: { schedule: 1 },
                        })
                        .catch(() => { });
                      // }
                      // this.$router.push({ path: '/lobbyJoin' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
                    }
                  }
              } else {
                this.$router
                  .push({
                    path: "/otp" + "/?uuid=" + this.uuid,
                    params: { schedule: 1 },
                  })
                  .catch(() => { });
              }
            }
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            if (this.namepagejoin === 1 || this.namepagejoin === "1") {
              this.$swal(this.$t("message.tryagain"), this.$t("message.wrongcode"), "warning").then(
                res => {
                  this.$router.push({ path: "/joinpage" }).catch(() => { });
                }
              );
            } else {
              this.$router.push({ path: "/" }).catch(() => { });
            }
          } else {
            if (this.namepagejoin === 1 || this.namepagejoin === "1") {
              this.$swal(this.$t("message.nomeeting"), this.$t("message.tryagain"), "warning").then(
                res => {
                  this.$router.push({ path: "/joinpage" }).catch(() => { });
                }
              );
            } else {
              this.$swal(this.$t("message.nomeeting"), this.$t("message.tryagain"), "warning").then(
                res => {
                  this.$router.push({ path: "/" }).catch(() => { });
                }
              );
            }
            // this.$swal(err.response.data.message, '', 'warning').then(res => {
            // this.$router.push({ path: '/' }).catch(() => {})
            // })
          }
        });
      // console.log('out')
      // this.$swal( '', 'warning').then(res => {})
    },
    checkmobile() {
      const vm = this;
      var agent = vm.isMobile();
      var sharetoken = localStorage.getItem("share-token") || this.$route.query.shared_token;
      if (sharetoken === null || sharetoken === undefined || sharetoken === "") {
        if (agent === "android" || agent === "ios") {
          // console.log('>> agent  else')
          //  console.log(agent)
          this.$swal
            .fire({
              title: "ต้องการเข้าใช้งาน One Meet",
              text: "ผ่าน ONE PLATFORM หรือไม่",
              // text: console.log(sharetoken),
              icon: "info",
              showCancelButton: true,
              confirmButtonText: "ONE PLATFORM",
              allowOutsideClick: false,
              cancelButtonText: "Web Browser",
            })
            .then(result => {
              // console.log('result', result)
              if (result.isConfirmed === true) {
                // console.log('result', true)
                this.openoneplatform();
              } else {
                return;
                // console.log('result', false)
              }
            });
        }
      }
    },
    async openoneplatform() {
      await this.axios
        .post(
          process.env.VUE_APP_PLATFORM_DYNAMIC_LINK +
            "/api/v2/service/create-conference-open-app",
          {
            app_id: "50b63901-ce2b-4cbd-a814-eb1208a1566e",
            zone: process.env.VUE_APP_ZONE,
            uuid: this.uuid,
            secret: "false",
            business_id: "",
          }
        )
        .then(res => {
          console.log("sssss", res);
          if (res.data.message === "success") {
            const deeplink = res.data.data.link;
            window.location.href = deeplink;
          }
        })
        .catch(err => {
          console.log("err", err);
          return;
        });
    },
    isMobile() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ) {
        if (/windows phone/i.test(userAgent)) {
          alert(userAgent);
          return "windows_phone";
        }
        if (/android/i.test(userAgent)) {
          return "android";
        }
        if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
          // alert("ios")
          return "ios";
        }
        if (/Macintosh/i.test(userAgent) && !window.MSStream) {
          alert(userAgent);
          // alert("ios")
          return "mac";
        }
        return "unknown";
      } else {
        // alert(false)
        var isTouchDevice =
          "ontouchstart" in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0;
        // var isMacLike = navigator.userAgent.includes('Intel Mac OS X');
        if (isTouchDevice && !window.MSStream) {
          return "ios";
        }
        return false;
      }
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY);
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8));
        return decryptedData;
      } catch (error) {
        console.log(">>>>>>>>", error);
        return error;
      }
    },
  },
};
</script>

<style scoped></style>
